import {Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {PortfolioService} from "../../pages/portfolio/portfolio.service";
import moment from "moment";
import {animate, state, style, transition, trigger} from "@angular/animations";
import { MaterialModule } from 'src/app/app.materials';
import { LineChartComponent } from '../line-chart/line-chart.component';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-etf-info-dialog',
    templateUrl: './etf-info-dialog.component.html',
    styleUrls: ['../company-info-dialog/company-info-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('100ms ease')),
        ]),
    ],
    standalone: true,
    imports: [MaterialModule, LineChartComponent, CommonModule],
})
export class EtfInfoDialogComponent implements OnInit {
  closeAdjData: any = [];
  sectionsA: any[] = [
    {
      id: 'name',
      title: 'Name',
      unit: ''
    },
    {
      id: 'broad_geo_desc',
      title: 'Region',
      unit: ''
    },
    {
      id: 'specific_geo_desc',
      title: 'Country',
      unit: ''
    },
    {
      id: 'sector',
      title: 'Sector',
      unit: ''
    },
    {
      id: 'focus_desc',
      title: 'Strategy',
      unit: ''
    },
    {
      id: 'econ_development_desc',
      title: 'Economic Development',
      unit: ''
    },
    {
      id: 'niche_desc',
      title: 'Niche',
      unit: ''
    },
    {
      id: 'aum',
      title: 'AUM',
      unit: 'M$',
      type: 'money'
    },{
      id: 'asset_class',
      title: 'Asset Class',
      unit: ''
    },
  ];

  sectionsB: any[] = [
    {
      id: 'brand_name',
      title: 'Brand Name',
      unit: ''
    },{
      id: 'category_desc',
      title: 'Category Description',
      unit: ''
    },{
      id: 'segment_desc',
      title: 'Segment Description',
      unit: ''
    }
    ,{
      id: 'isin',
      title: 'Isin',
      unit: ''
    }
    ,{
      id: 'iso_country',
      title: 'Iso country',
      unit: ''
    }
    ,{
      id: 'currency',
      title: 'Currency',
      unit: ''
    }
    ,{
      id: 'active_desc',
      title: 'Active desc',
      unit: ''
    }
    ,{
      id: 'nav_date',
      title: 'Price date',
      unit: ''
    }
    ,{
      id: 'launch_date',
      title: 'Launch date',
      unit: ''
    }
  ]

  companyName = '';
  overview: any = {};

  extraOptions = {
    tooltip: {
      xDateFormat: '%Y-%m-%d',
      valueSuffix: ' USD'
    }
  };

  constructor(
    public dialogRef: MatDialogRef<EtfInfoDialogComponent>,
    private service: PortfolioService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.dialogRef.afterOpened().subscribe(() => {
      this.initDialog();
    });
  }

  initDialog() {
    if (this.data.company) {
      let currency = 'USD';
      if (this.data.company && this.data.company.currency) {        
          currency = this.data.company.currency.code ? this.data.company.currency.code : this.data.company.currency;
      }
      this.extraOptions.tooltip.valueSuffix = ` ${currency}`;
      this.companyName = this.data.company.company_name;
      this.cdr.detectChanges();
      this.overview = this.data.company.etf_reference_table;
      this.fetchAdjChart();
    }
  }

  fetchAdjChart() {
    this.service.getETFCloseAdj(this.data.company.id).subscribe((resp: any) => {
      if (resp.etf_reference) {
        this.overview = resp.etf_reference;
      }
      if (resp.items) {
        const closeAdj = [];
        resp.items.map((r: any) => {
          closeAdj.push([moment(`${r.date} 12:00:00`).unix() * 1000, r.close_adj]);
        });

        // order closeAdj by nav_date
        closeAdj.sort((a: any, b: any) => a[0] - b[0]);

        // update the overview nav_date to the last closeAdj item date
        this.overview.nav_date = moment(closeAdj[closeAdj.length - 1][0]).format('YYYY-MM-DD');

        this.closeAdjData = [{
          name: this.companyName,
          data: closeAdj,
          tooltip: {
            valueDecimals: 2
          }
        }];
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
